import { render, staticRenderFns } from "./multipleChoice9.vue?vue&type=template&id=20c12886&scoped=true"
import script from "./multipleChoice9.vue?vue&type=script&lang=js"
export * from "./multipleChoice9.vue?vue&type=script&lang=js"
import style0 from "./multipleChoice9.vue?vue&type=style&index=0&id=20c12886&prod&lang=css"
import style1 from "./multipleChoice9.vue?vue&type=style&index=1&id=20c12886&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c12886",
  null
  
)

export default component.exports